// ============================================================================
// KOREAN TRANSLATIONS - CHAPTER 5: 초대 교회
// ============================================================================
// 레벨 53-65 (13개 레벨, 39개 질문)

export const chapter5Translations = {
  name: "초대 교회",
  description: "너희가 권능을 받고...",
  
  spiritualWisdom: {
    principle: "성령은 증거하기 위한 능력과 용기를 주신다",
    scripture: "오직 성령이 너희에게 임하시면 너희가 권능을 받고 내 증인이 되리라 (사도행전 1:8)",
    application: "교회는 성령의 불 가운데서 태어나고 담대한 증거로 성장한다"
  },
  
  levels: {
    53: {
      name: "승천",
      challenge: "너희는 내 증인이 되리라...땅 끝까지...",
      easy: {
        question: "예수님은 부활 후 며칠 만에 승천하셨습니까?",
        options: ["30일", "40일", "50일", "60일"],
        hint: "준비의 성경적 숫자",
        funFact: "☁️ 세계 선교 전 40일간의 집중 가르침!"
      },
      medium: {
        question: "예수님은 승천 전에 어떤 약속을 하셨습니까?",
        options: [
          "곧 다시 오시겠다",
          "능력으로 성령을 보내시겠다",
          "교회를 세우시겠다",
          "악인들을 벌하시겠다"
        ],
        hint: "위로부터 오는 능력",
        funFact: "⚡ 성령의 약속 - 두려워하는 제자들의 변화!"
      },
      hard: {
        question: "승천은 우리의 영적 삶에서 무엇을 상징합니까?",
        options: [
          "예수님의 임재의 끝",
          "예수님은 하늘에서 다스리시며 우리를 위해 중보하신다",
          "마지막 작별",
          "상징적 신화"
        ],
        hint: "영광받으신 살아계신 임재에 관한 것",
        funFact: "👑 예수님은 하나님 우편에 앉아 다스리시며 우리를 위해 중보하신다!"
      }
    },
    
    54: {
      name: "오순절",
      challenge: "다 성령의 충만함을 받고 말하기 시작하니라...",
      easy: {
        question: "승천 후 며칠 만에 오순절이 일어났습니까?",
        options: ["7일", "10일", "14일", "20일"],
        hint: "약 열흘",
        funFact: "🔟 10일간의 열렬한 기도가 성령의 부어짐을 준비한다!"
      },
      medium: {
        question: "성령은 어떤 형태로 나타나셨습니까?",
        options: [
          "강한 바람처럼",
          "불의 혀같이 갈라진 것처럼",
          "비둘기처럼",
          "빛처럼"
        ],
        hint: "각 제자 위에 머무는 불꽃",
        funFact: "🔥 불의 혀: 성령께서 용기와 방언의 은사를 주신다!"
      },
      hard: {
        question: "오순절은 보편 교회에 무엇을 나타냅니까?",
        options: [
          "고립된 역사적 사건",
          "선교 교회의 공식적인 탄생",
          "호기심의 기적",
          "축제의 시작"
        ],
        hint: "교회의 출생 증명서에 관한 것",
        funFact: "🎂 오순절 = 교회의 생일, 세계 선교의 시작!"
      }
    },

    55: {
      name: "베드로의 첫 설교",
      challenge: "우리가 어찌할꼬, 형제들아? 회개하라...",
      easy: {
        question: "베드로의 설교 후 몇 명이 세례를 받았습니까?",
        options: ["1000명", "2000명", "3000명", "5000명"],
        hint: "삼천 영혼",
        funFact: "🌊 하루에 3000명의 세례 - 놀라운 영적 각성!"
      },
      medium: {
        question: "베드로는 군중을 무엇으로 책망했습니까?",
        options: [
          "무지",
          "메시아이신 예수님을 십자가에 못 박은 것",
          "믿음 부족",
          "위선"
        ],
        hint: "하나님의 아들에 대한 최고의 죄",
        funFact: "⚔️ 예수님을 부인했던 베드로가 이제 그분의 신성을 선포한다!"
      },
      hard: {
        question: "베드로의 변화는 성령의 역사를 어떻게 보여줍니까?",
        options: [
          "더 교양있게 됨",
          "겁많고 불안정한 자에서 담대하고 믿음에 굳건한 자로",
          "권력을 얻음",
          "성격이 바뀜"
        ],
        hint: "성령에 의한 성화에 관한 것",
        funFact: "🗿 '흔들리는 갈대'가 '견고한 반석'이 되다 - 변화의 능력!"
      }
    },

    56: {
      name: "첫 공동체",
      challenge: "사도의 가르침과 교제에 전념하더라...",
      easy: {
        question: "첫 그리스도인들은 재산을 어떻게 나누었습니까?",
        options: [
          "각자 자기 것을 보관했다",
          "모든 것을 공유했다",
          "부자들만 주었다",
          "법적 의무에 의해"
        ],
        hint: "자발적인 재산 공유",
        funFact: "🤝 형제애가 너무 강렬해서 자발적으로 모든 것을 나눴다!"
      },
      medium: {
        question: "첫 그리스도인들은 무엇에 시간을 보냈습니까?",
        options: [
          "사업만",
          "가르침, 교제, 떡 떼기, 기도",
          "일만",
          "여가"
        ],
        hint: "공동 생활의 네 기둥",
        funFact: "⛪ 가르침, 교제, 성찬, 기도 - 교회의 기초!"
      },
      hard: {
        question: "왜 이 첫 공동체가 그렇게 매력적이었습니까?",
        options: [
          "부유했기 때문",
          "진정한 사랑과 기쁨이 그들의 일치에서 빛났기 때문",
          "기적을 약속했기 때문",
          "다른 사람들을 비판했기 때문"
        ],
        hint: "살아있는 사랑의 증거에 관한 것",
        funFact: "✨ '보라, 그들이 어떻게 서로 사랑하는지!' - 말보다 더 설득력 있는 증거!"
      }
    },

    57: {
      name: "앉은뱅이의 치유",
      challenge: "은과 금은 내게 없거니와 내게 있는 이것을 네게 주노니...",
      easy: {
        question: "그 사람은 얼마나 오래 앉은뱅이였습니까?",
        options: [
          "20년",
          "30년", 
          "태어날 때부터",
          "10년"
        ],
        hint: "태어날 때부터의 장애",
        funFact: "🚶 40년간의 장애가 예수님의 이름으로 즉시 치유되다!"
      },
      medium: {
        question: "베드로는 누구의 이름으로 앉은뱅이를 치유했습니까?",
        options: [
          "하나님의 이름으로",
          "나사렛 예수 그리스도의 이름으로",
          "자기 이름으로",
          "아브라함의 이름으로"
        ],
        hint: "모든 이름 위에 뛰어난 이름",
        funFact: "✊ 예수님의 이름은 사도들을 통해 계속 기적을 행한다!"
      },
      hard: {
        question: "이 치유는 복음에 대해 무엇을 상징합니까?",
        options: [
          "단순한 의학적 기적",
          "예수님이 가져오시는 완전한 구원: 영적이고 육체적인",
          "사도들의 능력",
          "가난한 자들을 위한 자선"
        ],
        hint: "인간의 완전한 구원에 관한 것",
        funFact: "🩺 예수님은 영혼과 몸을 치유하신다 - 사람의 완전한 구원!"
      }
    },

    58: {
      name: "박해의 시작",
      challenge: "사람보다 하나님께 순종하는 것이 마땅하니라...",
      easy: {
        question: "앉은뱅이 치유 후 누가 베드로와 요한을 체포했습니까?",
        options: [
          "로마인들",
          "사두개인들과 제사장들",
          "백성",
          "빌라도"
        ],
        hint: "유대 종교 당국",
        funFact: "⛓️ 첫 종교적 박해 - 복음이 기득권층을 흔든다!"
      },
      medium: {
        question: "당국은 사도들에게 무엇을 금지했습니까?",
        options: [
          "예루살렘을 떠나는 것",
          "예수의 이름으로 더 이상 가르치지 말 것",
          "더 이상 기적을 행하지 말 것",
          "더 이상 기도하지 말 것"
        ],
        hint: "설교 금지",
        funFact: "🚫 진리를 침묵시키려는 시도 - 복음을 멈출 수 없다!"
      },
      hard: {
        question: "사도들은 금지에 어떻게 반응했습니까?",
        options: [
          "두려워하며 복종했다",
          "사람보다 하나님께 순종하는 것이 마땅하다고 단언했다",
          "협상했다",
          "도망쳤다"
        ],
        hint: "인간의 법보다 높은 충성에 관한 것",
        funFact: "⚖️ 하나님께 순종하기 위한 시민 불복종 - 확신의 용기!"
      }
    },

    59: {
      name: "아나니아와 삽비라",
      challenge: "네가 사람에게 거짓말한 것이 아니요 하나님께로다...",
      easy: {
        question: "아나니아와 삽비라는 어떤 거짓말을 했습니까?",
        options: [
          "아무것도 팔지 않았다",
          "일부를 감추고 전액을 드렸다고 말했다",
          "가난했다",
          "결혼하지 않았다"
        ],
        hint: "드린 금액에 대한 거짓말",
        funFact: "💰 일부를 남겨두는 것은 허용되었지만, 헌금에 대해 거짓말하는 것은 안 된다!"
      },
      medium: {
        question: "거짓말 후 그들에게 무슨 일이 일어났습니까?",
        options: [
          "용서받았다",
          "즉시 죽었다",
          "추방당했다",
          "회개했다"
        ],
        hint: "즉각적인 엄중한 징벌",
        funFact: "⚱️ 갓 태어난 교회의 순결함을 지키기 위한 엄중한 심판!"
      },
      hard: {
        question: "왜 교회 초기에 이렇게 엄중한 징벌이 있었습니까?",
        options: [
          "하나님이 잔인하셨기 때문",
          "공동체에 요구되는 거룩함을 확립하기 위해",
          "두려움을 주기 위해",
          "우연"
        ],
        hint: "영적 진실성을 지키는 것에 관한 것",
        funFact: "🔥 거룩함의 문화를 확립하기 위해 초기에 높은 기준!"
      }
    },

    60: {
      name: "일곱 집사",
      challenge: "너희 가운데서 칭찬 받는 사람 일곱을 택하라...",
      easy: {
        question: "몇 명의 집사가 선택되었습니까?",
        options: ["5명", "6명", "7명", "12명"],
        hint: "완전함의 숫자",
        funFact: "7️⃣ 섬김을 위한 일곱 집사 - 교회의 신적 조직!"
      },
      medium: {
        question: "그들의 주요 역할은 무엇이었습니까?",
        options: [
          "복음 전파",
          "식탁에서 섬기고 과부들을 돕는 것",
          "새 개종자들에게 세례를 주는 것",
          "재정 관리"
        ],
        hint: "사회적 물질적 섬김",
        funFact: "🍽️ 식탁 섬김 = 최초의 기독교 자선 조직!"
      },
      hard: {
        question: "이 조직은 섬김에 대한 기독교적 비전에 대해 무엇을 드러냅니까?",
        options: [
          "물질적 일은 열등하다",
          "영적 섬김과 물질적 섬김 모두 거룩하다",
          "거룩한 것과 세속적인 것을 분리해야 한다",
          "제사장만 진정으로 섬긴다"
        ],
        hint: "모든 사랑의 섬김의 거룩함에 관한 것",
        funFact: "✨ 설교와 같은 존엄성으로 식탁에서 섬기다 - 모든 섬김은 거룩하다!"
      }
    },

    61: {
      name: "스데반, 첫 순교자",
      challenge: "주여, 이 죄를 그들에게 돌리지 마옵소서! 이 말을 하고 자니라...",
      easy: {
        question: "스데반의 교회에서의 역할은 무엇이었습니까?",
        options: ["사도", "집사", "제사장", "선지자"],
        hint: "섬기기 위해 선택된 일곱 중 하나",
        funFact: "✨ 스데반: 집사가 강력한 전도자이자 첫 순교자가 되다!"
      },
      medium: {
        question: "스데반은 유대 지도자들을 무엇으로 비난했습니까?",
        options: [
          "부패",
          "항상 성령을 거역해 온 것",
          "위선",
          "탐욕"
        ],
        hint: "하나님에 대한 역사적 저항",
        funFact: "📜 스데반은 역사를 요약한다: 하나님께 대한 끊임없는 반역!"
      },
      hard: {
        question: "스데반은 어떻게 죽었으며, 그의 태도는 무엇을 드러냅니까?",
        options: [
          "처형자들에 대한 분노 속에서",
          "십자가의 예수님처럼 용서하며",
          "절망 속에서",
          "원수들을 저주하며"
        ],
        hint: "그리스도의 완전한 모방에 관한 것",
        funFact: "💝 처형자들을 용서함: 스데반은 예수님의 태도를 완벽히 재현한다!"
      }
    },

    62: {
      name: "빌립과 에티오피아 내시",
      challenge: "지도해 주는 사람이 없으면 어찌 깨달을 수 있느뇨?",
      easy: {
        question: "내시는 마차에서 무엇을 읽고 있었습니까?",
        options: [
          "시편",
          "선지자 이사야",
          "창세기",
          "잠언"
        ],
        hint: "메시아의 수난을 예언한 선지자",
        funFact: "📖 이사야 53장 - 진실한 구도자가 읽는 예수님에 대한 완벽한 예언!"
      },
      medium: {
        question: "빌립은 이사야 구절을 어떻게 설명했습니까?",
        options: [
          "고대 역사에 대해 이야기했다",
          "이 본문에서 예수님을 전했다",
          "신학 강의를 했다",
          "해석을 비판했다"
        ],
        hint: "성경은 자연스럽게 그리스도께로 인도한다",
        funFact: "✝️ 모든 성경이 예수님께 수렴된다 - 이해의 열쇠!"
      },
      hard: {
        question: "에티오피아 내시의 개종은 무엇을 상징합니까?",
        options: [
          "고립된 개종",
          "모든 인종과 신분을 위한 복음의 보편성",
          "특정 민족의 우월성",
          "특별한 경우"
        ],
        hint: "열방을 향한 개방에 관한 것",
        funFact: "🌍 에티오피아인, 내시, 대신: 복음은 모든 장벽을 무너뜨린다!"
      }
    },

    63: {
      name: "다소의 사울의 회심",
      challenge: "사울아, 사울아, 네가 어찌하여 나를 박해하느냐?",
      easy: {
        question: "사울은 회심 전에 무엇을 하고 있었습니까?",
        options: [
          "복음을 전하고 있었다",
          "그리스도인들을 박해하고 있었다",
          "중립이었다",
          "공부만 하고 있었다"
        ],
        hint: "제자들의 맹렬한 적",
        funFact: "⚔️ 사울은 예수님의 제자들에 대한 위협과 살기로 숨을 쉬고 있었다!"
      },
      medium: {
        question: "예수님은 사울에게 어느 길에서 나타나셨습니까?",
        options: [
          "예루살렘 가는 길",
          "다마스커스 가는 길",
          "가사 가는 길",
          "안디옥 가는 길"
        ],
        hint: "시리아의 도시",
        funFact: "🛤️ 다마스커스 길 = 역사상 가장 유명한 변화의 장소!"
      },
      hard: {
        question: "이 회심은 하나님의 은혜를 어떻게 보여줍니까?",
        options: [
          "하나님은 선한 사람만 개종시키신다",
          "은혜는 최악의 적을 가장 위대한 사도로 변화시킬 수 있다",
          "회심은 당연한 것이었다",
          "사울은 이미 하나님께 가까웠다"
        ],
        hint: "은혜의 변화시키는 능력에 관한 것",
        funFact: "⚡ 최대의 박해자에서 최대의 선교사로 - 은혜의 기적!"
      }
    },

    64: {
      name: "베드로와 고넬료",
      challenge: "하나님은 사람의 외모를 보지 아니하시는 줄 내가 참으로 깨달았도다...",
      easy: {
        question: "고넬료의 직업은 무엇이었습니까?",
        options: [
          "상인",
          "로마 백부장",
          "제사장",
          "율법학자"
        ],
        hint: "로마군 장교",
        funFact: "🎖️ 공식적으로 개종한 첫 이방인 - 비유대인들을 향한 개방!"
      },
      medium: {
        question: "베드로는 고넬료를 만나기 전에 어떤 환상을 보았습니까?",
        options: [
          "말하는 천사",
          "정한 짐승과 부정한 짐승이 있는 보자기",
          "예수님이 나타나심",
          "파괴된 성전"
        ],
        hint: "정함과 부정함에 대한 환상",
        funFact: "🕊️ 짐승이 있는 보자기: 하나님께서 음식과 인종의 구별을 폐지하신다!"
      },
      hard: {
        question: "이 개종은 어떤 혁명적 원리를 확립했습니까?",
        options: [
          "로마인이 우월하다",
          "하나님은 사람의 외모를 보지 아니하신다 - 보편적 구원",
          "전통을 버려야 한다",
          "할례가 쓸모없다"
        ],
        hint: "구원의 보편성에 관한 것",
        funFact: "🌍 영적 혁명: 복음은 예외 없이 모든 민족을 위한 것!"
      }
    },

    65: {
      name: "안디옥 교회",
      challenge: "안디옥에서 제자들이 비로소 그리스도인이라 일컬음을 받게 되었더라...",
      easy: {
        question: "안디옥에서 제자들이 처음으로 무엇이라 불렸습니까?",
        options: ["제자", "그리스도인", "신자", "성도"],
        hint: "오늘날 우리가 가진 이름",
        funFact: "✝️ '그리스도인' = '작은 그리스도' - 이방인들이 준 명예로운 이름!"
      },
      medium: {
        question: "바나바와 함께 안디옥에서 가르치기 위해 누가 왔습니까?",
        options: [
          "베드로",
          "바울 (사울)",
          "야고보",
          "요한"
        ],
        hint: "사도가 된 전 박해자",
        funFact: "👥 바나바가 다소에서 바울을 찾다 - 바울의 사역 시작!"
      },
      hard: {
        question: "왜 안디옥이 기독교 역사에서 그렇게 중요해졌습니까?",
        options: [
          "부유했기 때문",
          "이방인들을 향한 첫 선교 센터",
          "좋은 위치에 있었기 때문",
          "좋은 지도자들이 있었기 때문"
        ],
        hint: "선교 확장에 관한 것",
        funFact: "🚢 안디옥: 바울의 유럽으로의 모든 선교 여행의 출발 항구!"
      }
    }
  }
};

export default chapter5Translations;
